import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link, NavLink, useLocation } from 'react-router-dom';

import { Container } from '../../styles/Common';

const NavbarMobile = () => {
  const location = useLocation();
  const [isSideNavActive, setIsSideNavActive] = useState<boolean>(false);

  useEffect(() => {
    setIsSideNavActive(false);
  }, [location.pathname, location.hash]);

  return (
    <>
      <Wrapper>
        <Container>
          <Inner>
            <Logo to="/">
              <img src="/assets/icons/logo.png" alt="" />
            </Logo>
            <Hamburger onClick={() => setIsSideNavActive(true)}>
              <img src="/assets/icons/mobile-hamburger-icon.png" alt="" />
            </Hamburger>
          </Inner>
        </Container>
      </Wrapper>
      <SideNavWrapper active={isSideNavActive}>
        <SideNavInner>
          <SideNavTop>
            <Logo to="/">
              <img src="/assets/icons/logo.png" alt="mobile-icon" />
            </Logo>
            <SideNavCloseIcon onClick={() => setIsSideNavActive(false)}>
              <img
                src="/assets/icons/mobile-side-nav-drawer-cross-icon.png"
                alt="mobile-icon"
              />
            </SideNavCloseIcon>
          </SideNavTop>
          <MenuWrapper>
            <MenuItem to="/">HOME</MenuItem>
            <MenuItem to="/fulfillment">FULFILLMENT</MenuItem>
            <MenuItem to="/marketing">MARKETING</MenuItem>
            <ContactMenuItem
              href="https://calendly.com/info-ripify"
            >
              CONTACT US
            </ContactMenuItem>
          </MenuWrapper>
        </SideNavInner>
      </SideNavWrapper>
    </>
  );
};

export default NavbarMobile;

const Wrapper = styled.div`
  padding: 20px 0;
  width: 100%;
`;

const Inner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Logo = styled(Link)`
  img {
    width: 110px;
    height: auto;
  }
`;

const Hamburger = styled.div`
  width: 26px;

  img {
    width: 100%;
    height: auto;
  }
`;

const SideNavWrapper = styled.div<any>`
  position: fixed;
  z-index: 9999999;
  top: 0;
  transition: 0.3s;
  left: ${(props: any) => (props?.active ? 0 : '-100vw')};
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: #d4ecff;
  padding: 20px 15px;
`;

const SideNavInner = styled.div`
  width: 100%;
`;

const SideNavTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SideNavCloseIcon = styled.div`
  img {
    width: 35px;
    height: auto;
  }
`;

const MenuWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
`;

const MenuItem = styled(NavLink)`
  display: inline-block;
  margin-bottom: 20px;
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  font-family: font-semibold;
  text-decoration: none;

  &.active {
    color: #479adf;
  }
`;

const ContactMenuItem = styled.a<any>`
  display: inline-block;
  margin-bottom: 20px;
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  font-family: font-semibold;
  text-decoration: none;

  &.active {
    color: #479adf;
  }
`;
